export default __webpack_public_path__ + "static/media/AdvanceVerfication.f4bcfd00.svg";